import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './TopicDetail.css';

const normalizeName = (name) => name.replace(/-/g, ' ').replace(/%20/g, ' ');

const generateUrl = (name) => name.toLowerCase().replace(/ /g, '-').replace(/\//g, '-');

const TOPIC_IMAGES = {
  'Healthcare in America': 'https://plus.unsplash.com/premium_vector-1682270091935-677cd4ff2f4e?w=1600&auto=format&fit=crop&q=80',
  'Space Exploration': 'https://images.unsplash.com/photo-1710267224163-0ee7e0d7a7ce?w=1600&auto=format&fit=crop&q=80',
  'Economic Inequality': 'https://plus.unsplash.com/premium_vector-1682308945349-2240669b8357?w=1600&auto=format&fit=crop&q=80',
  'Russia Ukraine Conflict': 'https://images.unsplash.com/photo-1597521624282-e6e107174935?w=1600&auto=format&fit=crop&q=80',
  'Artificial Intelligence': 'https://plus.unsplash.com/premium_photo-1664297939846-330cfd170bae?w=1600&auto=format&fit=crop&q=80',
  'Race in America': 'https://plus.unsplash.com/premium_photo-1675034789850-867f7b9e9c04?w=1600&auto=format&fit=crop&q=80',
  'Modern Slavery and Forced Labor': 'https://plus.unsplash.com/premium_vector-1726068623445-27911ac99388?w=1600&auto=format&fit=crop&q=80',
  'Overtourism': 'https://images.unsplash.com/photo-1468704971477-0211e6c57317?w=1600&auto=format&fit=crop&q=80',
  'COVID 19': 'https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=1600&auto=format&fit=crop&q=80',
  'Israel Palestine Conflict': 'https://plus.unsplash.com/premium_photo-1708038152579-f7d74634faa5?w=1600&auto=format&fit=crop&q=80',
  'Gun Control': 'https://images.unsplash.com/photo-1607768178747-f4933d20ce75?w=1600&auto=format&fit=crop&q=80',
  'Climate Change': 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=1600&auto=format&fit=crop&q=80',
  'The Immigration Debate': 'https://images.unsplash.com/photo-1655722724451-0df658a2ab23?w=1600&auto=format&fit=crop&q=80',
  'Cryptocurrency and Blockchain': 'https://images.unsplash.com/photo-1639133893916-a711d8af8c0a?w=1600&auto=format&fit=crop&q=80',
  'Life After Death': 'https://plus.unsplash.com/premium_vector-1698192215880-390bdcd0a476?w=1600&auto=format&fit=crop&q=80',
  'Gender Identity': 'https://images.unsplash.com/photo-1545693315-85b6be26a3d6?w=1600&auto=format&fit=crop&q=80',
  'Globalization': 'https://images.unsplash.com/photo-1576185850227-1f72b7f8d483?w=1600&auto=format&fit=crop&q=80',
  'Ocean Exploration': 'https://images.unsplash.com/photo-1530053969600-caed2596d242?w=1600&auto=format&fit=crop&q=80',
  'Aging and Longevity': 'https://plus.unsplash.com/premium_photo-1663054337016-50a4ce0964e0?w=1600&auto=format&fit=crop&q=80',
  'Surveillance and Privacy': 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=1600&auto=format&fit=crop&q=80',
  'Nutrition': 'https://images.unsplash.com/photo-1535914254981-b5012eebbd15?w=1600&auto=format&fit=crop&q=80',
  'Media and Information': 'https://images.unsplash.com/photo-1503694978374-8a2fa686963a?w=1600&auto=format&fit=crop&q=80',
  'Mental Health': 'https://images.unsplash.com/photo-1493836512294-502baa1986e2?w=1600&auto=format&fit=crop&q=80',
  'Drugs, Addiction & Policy': 'https://plus.unsplash.com/premium_photo-1663054867469-de665663b843?w=1600&auto=format&fit=crop&q=80',
  'Genetic Engineering': 'https://images.unsplash.com/photo-1643780668909-580822430155?w=1600&auto=format&fit=crop&q=80',
  'Education Reform': 'https://plus.unsplash.com/premium_photo-1681487787308-52f293cd3bce?w=1600&auto=format&fit=crop&q=80',
  "America's Wars Abroad": 'https://plus.unsplash.com/premium_photo-1661901234139-d833950e05e0?w=1600&auto=format&fit=crop&q=80',
  'The Role of Government in Society': 'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=1600&auto=format&fit=crop&q=80',
  'Free Speech': 'https://plus.unsplash.com/premium_photo-1682308291504-3d0244025f20?w=1600&auto=format&fit=crop&q=80',
  'Housing Costs & Homelessness': 'https://images.unsplash.com/photo-1612637968894-660373e23b03?w=1600&auto=format&fit=crop&q=80',
};


const formatAnswer = (text) => {
  if (!text) return null;
  return text.split('\n\n').map((paragraph, i) => {
    const formatted = paragraph
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br />');
    return <p key={i} dangerouslySetInnerHTML={{ __html: formatted }} />;
  });
};
const TopicDetail = () => {
  const { name } = useParams();
  const [topic, setTopic] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const normalizedName = normalizeName(name);

    console.log('Fetching topic:', normalizedName);

    axios.get(`${apiUrl}/api/topics/${normalizedName}`)
      .then(response => {
        console.log('Fetched topic data:', response.data);
        if (response.data) {
          setTopic(response.data);
          fetchQuestions(response.data._id);
        } else {
          console.error('No topic found with the given name');
        }
      })
      .catch(error => console.error('Error fetching topic:', error));
  }, [name]);

  const fetchQuestions = async (topicId) => {
    try {
      const response = await axios.get(`/api/topics/${topicId}/questions`);
      setQuestions(response.data);
    } catch (error) {
      console.error('Error fetching questions:', error);
    }
  };

  const fetchAnswer = async (question) => {
    setAnswer('Loading...');
    try {
      const response = await axios.post('/api/chatbot', { question });
      setAnswer(response.data.answer);
    } catch (error) {
      console.error('Error fetching answer:', error);
      setAnswer('Sorry, there was an error fetching the answer.');
    }
  };

  const handleQuestionClick = (question) => {
    setSelectedQuestion(question);
    fetchAnswer(question);
  };

  if (!topic) return <div className="container mt-5">Loading...</div>;

  return (
    <div className="topic-detail-container">
      <Helmet>
        <title>{topic.name} - The Other Side</title>
        <meta name="description" content={`Explore balanced perspectives and comprehensive information on ${topic.name}.`} />
        <meta name="keywords" content={`balanced perspectives, ${topic.name}, ${topic.subtopics && topic.subtopics.map(sub => sub.name).join(', ')}`} />
        <link rel="canonical" href={`https://www.theotherside.media/topics/${generateUrl(topic.name)}`} />
      </Helmet>
      <div className="topic-content">
        <div className="topic-header" style={TOPIC_IMAGES[topic.name] ? { backgroundImage: `linear-gradient(rgba(30, 58, 92, 0.45), rgba(30, 58, 92, 0.55)), url(${TOPIC_IMAGES[topic.name]})` } : {}}>
          <h2 className={TOPIC_IMAGES[topic.name] ? 'hero-title' : ''}>{topic.name}</h2>
          <p className={TOPIC_IMAGES[topic.name] ? 'hero-description' : 'centered-description'}>{topic.description}</p>
        </div>
        <div className="subtopics-container">
         <div className="subtopics-grid">
            {topic.subtopics && topic.subtopics.length > 0 ? (
              topic.subtopics.map((subtopic, index) => (
                <div key={index} className="subtopic-card">
                  <h4>{subtopic.name}</h4>
                  <Link to={`/subtopics/${subtopic._id}`} className="learn-more-button">Learn More</Link>
                </div>
              ))
            ) : (
              <p>No subtopics found.</p>
            )}
          </div>
        </div>
      </div>
      <div className="chatbot-container">
        <h3 className="chatbot-header">Ask Questions</h3>
        <div className="questions-container">
          {questions.map((q, index) => (
            <button
              key={index}
              className="question-button"
              onClick={() => handleQuestionClick(q.question)}
            >
              {q.question}
            </button>
          ))}
        </div>
        {selectedQuestion && (
          <div className="answer-container">
            <h4>Question:</h4>
            <p>{selectedQuestion}</p>
            <h4>Answer:</h4>
            <div>{formatAnswer(answer)}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopicDetail;
